import { Tooltip } from '@progress/kendo-react-tooltip';
import { dispatchEvent } from '@progress/kendo-react-common';

class PuzzleTooltip extends Tooltip {
  static defaultProps = {
    className: 'tp-puzzle-tooltip',
    anchorElement: 'target',
    openDelay: 1000,
    position: 'top',
    showCallout: true,
    parentTitle: true
  }
  /**
   * @override
   */
  public handleMouseOut = (event: any) => {
    dispatchEvent(this.props.onClose, event, this, undefined);

    if (this.props.open) {
      return;
    }

    // @ts-ignore
    clearInterval(this.updateIntervalId);
    // @ts-ignore
    this.willOpen = false;
    // @ts-ignore
    this.onClose(event);
  };
}

export default PuzzleTooltip;
